<div id="skip-content-container" tabindex="-1">
  <div class="d-none d-lg-block" id="skip-content">
    <a
      (click)="navigateToFirstElement()"
      class="skip-main-content"
      href="javascript:void(0);"
      id="skip-main-content"
    >
      {{ textToDisplay }}
    </a>
  </div>
</div>
